import { defineAction } from '~/prix'
import actionJson from './privateFileDelete.action.json' with { type: 'json' }
import { z } from 'zod'

const privateFileDeleteDefinition = defineAction({
  ...actionJson,
  input: z.object({
    fileId: z.string().uuid(),
  }),
  output: z.object({}),
})

export default privateFileDeleteDefinition
